import { render } from "./Incoming.vue?vue&type=template&id=2ad86342&scoped=true"
import script from "./Incoming.vue?vue&type=script&lang=js"
export * from "./Incoming.vue?vue&type=script&lang=js"

import "./Incoming.vue?vue&type=style&index=0&id=2ad86342&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad86342"]])

export default __exports__